<template>
  <item-box class-suffix="checkbox">
    <el-form-item label="ID">
      <el-input v-model="data.fieldId" disabled />
    </el-form-item>
    <el-form-item label="标签">
      <el-input v-model="data.label" />
    </el-form-item>
    <el-form-item label="远程数据">
      <el-switch v-model="data.setting.isRemote" active-text="是" inactive-text="否" />
    </el-form-item>
    <el-form-item v-if="!data.setting.isRemote" label="选项">
      <el-checkbox-group v-model="data.defaultValue">
        <div v-for="item in data.selections" :key="item.value" class="he-setting-checkbox--checkbox">
          <el-checkbox :label="item.value">
            <span v-text="item.label" />
          </el-checkbox>
          <span class="he-setting-checkbox--checkbox--delete"><i class="el-icon-delete" @click.stop="delCheckbox(item)" /></span>
          <span v-show="data.defaultValue.includes(item.value)" class="he-setting-checkbox--checkbox--default-text">默认选择</span>
        </div>
      </el-checkbox-group>
      <div v-if="inputing" class="he-setting-checkbox--add">
        <el-form :inline="true" :model="addForm" class="he-setting-checkbox--add--form" :rules="rules">
          <el-form-item prop="label">
            <el-input v-model="addForm.label" size="mini" placeholder="请输入标签" />
          </el-form-item>
          <el-form-item prop="value">
            <el-input v-model="addForm.value" size="mini" placeholder="请输入值" />
          </el-form-item>
        </el-form>
        <el-button type="primary" icon="el-icon-check" size="mini" @click="add" />
        <el-button type="info" icon="el-icon-close" size="mini" @click="inputing=!inputing" />
      </div>
      <el-button v-else type="text" icon="el-icon-plus" size="mini" @click="inputing=!inputing;addForm.label='';addForm.value=''">添加一项</el-button>
    </el-form-item>
    <template v-else>
      <el-form-item label="请求地址">
        <el-input v-model="data.setting.remoteUrl" placeholder="请输入远程地址" @blur="getRemoteData" />
      </el-form-item>
      <el-form-item label="数据路径">
        <el-input v-model="data.setting.remoteDataPath" placeholder="请输入远程获取路径">
          <template slot="prepend">data.</template>
        </el-input>
      </el-form-item>
      <el-form-item label="Label">
        <el-input v-model="data.setting.remoteDataProps.label" placeholder="远程数据中的label" />
      </el-form-item>
      <el-form-item label="Value">
        <el-input v-model="data.setting.remoteDataProps.value" placeholder="远程数据中的value" />
      </el-form-item>
      <el-form-item label="远程数据">
        <div v-if="!remoteData || remoteData.length === 0">暂无数据</div>
        <el-checkbox-group v-model="data.defaultValue">
          <div v-for="item in remoteData" :key="item[data.setting.remoteDataProps.value]" class="he-setting-checkbox--checkbox">
            <el-checkbox :label="item[data.setting.remoteDataProps.value]">
              <span v-text="item[data.setting.remoteDataProps.label]" />
            </el-checkbox>
            <span class="he-setting-checkbox--checkbox--delete"><i class="el-icon-delete" @click.stop="delCheckbox(item)" /></span>
            <span v-show="data.defaultValue.includes(item[data.setting.remoteDataProps.value])" class="he-setting-checkbox--checkbox--default-text">默认选择</span>
          </div>
        </el-checkbox-group>
      </el-form-item>
    </template>
  </item-box>
</template>

<script>
import _ from 'lodash'
import ItemBox from '../../common/setting/ItemBox'
import RemoteMixin from '../../mixins/remote'
export default {
  name: 'CheckboxSetting',
  components: { ItemBox },
  mixins: [RemoteMixin],
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      inputing: false,
      addForm: {
        label: '',
        value: ''
      },
      rules: {
        label: [{ required: true, message: '请输入标签', trigger: 'blur' }],
        value: [{ required: true, message: '请输入值', trigger: 'blur' }]
      }
    }
  },
  computed: {
  },
  methods: {
    delCheckbox(item) {
      const i = this.data.selections.findIndex(s => s === item)
      this.data.selections.splice(i, 1)
      const j = this.data.defaultValue.indexOf(item.value)
      if (j > -1) {
        this.data.defaultValue.splice(j, 1)
      }
    },
    add() {
      if (_.trim(this.addForm.label) !== '' && _.trim(this.addForm.value) !== '') {
        this.data.selections.push({ ...this.addForm })
        this.inputing = !this.inputing
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../index.scss';
.he-setting-checkbox {
  &--checkbox {
    width: 100%;
    font-size: 14px;
    &--delete {
      cursor: pointer;
      color: $error-color;
      margin-left: 20px;
    }
    &--default-text {
      margin-left: 20px;
      color: $primary-color;
    }
  }

  &--add {
    width: 100%;
    @include display-flex(row, nowrap, space-between, center);
    &--form {
      flex-grow: 1;
      @include display-flex(row, nowrap, space-between, center);
    }
  }
}
</style>
